import api, {
  buildActivityScopeHeaders,
  buildCompanyScopeHeaders,
} from "./api";

export const DEFAULT_SUPPLIER_PAGE_SIZE = 20;

function normalizePositiveInteger(
  value,
  fallback,
) {
  const parsed = Number.parseInt(value, 10);

  if (!Number.isInteger(parsed) || parsed <= 0) {
    return fallback;
  }

  return parsed;
}

function normalizeSearch(search) {
  if (typeof search !== "string") {
    return "";
  }

  return search.trim();
}

export function buildSupplierListParams({
  search = "",
  page = 1,
  pageSize = DEFAULT_SUPPLIER_PAGE_SIZE,
} = {}) {
  const params = {
    page: normalizePositiveInteger(page, 1),
    page_size: normalizePositiveInteger(
      pageSize,
      DEFAULT_SUPPLIER_PAGE_SIZE,
    ),
  };

  const normalizedSearch = normalizeSearch(search);

  if (normalizedSearch) {
    params.search = normalizedSearch;
  }

  return params;
}

export async function listSuppliers({
  companyUuid,
    activityUuid,
  search = "",
  page = 1,
  pageSize = DEFAULT_SUPPLIER_PAGE_SIZE,
} = {}) {
  const response = await api.get(
    "/supply-chain/suppliers",
    {
      headers: {
        ...buildCompanyScopeHeaders(
          companyUuid,
        ),
        ...buildActivityScopeHeaders(
          activityUuid,
        ),
      },
      params: buildSupplierListParams({
        search,
        page,
        pageSize,
      }),
    },
  );

  return response.data;
}

export async function getSupplier(
  supplierUuid,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  if (
    typeof supplierUuid !== "string"
    || !supplierUuid.trim()
  ) {
    throw new TypeError(
      "supplierUuid must be a non-empty string.",
    );
  }

  const response = await api.get(
    `/supply-chain/suppliers/${encodeURIComponent(
      supplierUuid.trim(),
    )}`,
    {
      headers: {
        ...buildCompanyScopeHeaders(
          companyUuid,
        ),
        ...buildActivityScopeHeaders(
          activityUuid,
        ),
      },
    },
  );

  return response.data;
}

export async function createSupplier(
  payload,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  const response = await api.post(
    "/supply-chain/suppliers",
    payload,
    {
      headers: {
        ...buildCompanyScopeHeaders(
          companyUuid,
        ),
        ...buildActivityScopeHeaders(
          activityUuid,
        ),
      },
    },
  );

  return response.data;
}

export async function updateSupplier(
  supplierUuid,
  payload,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  if (
    typeof supplierUuid !== "string"
    || !supplierUuid.trim()
  ) {
    throw new TypeError(
      "supplierUuid must be a non-empty string.",
    );
  }

  const response = await api.patch(
    `/supply-chain/suppliers/${encodeURIComponent(
      supplierUuid.trim(),
    )}`,
    payload,
    {
      headers: {
        ...buildCompanyScopeHeaders(
          companyUuid,
        ),
        ...buildActivityScopeHeaders(
          activityUuid,
        ),
      },
    },
  );

  return response.data;
}
